import { RootState } from '.';

export const selectAccount = (state: RootState) => {
  return state.auth.account;
};

export const selectCheckingAuthentication = (state: RootState) => {
  return state.auth.checkingAuthentication;
};

export const selectAuthenticated = (state: RootState) => {
  return state.auth.isAuthenticated;
};

export const selectAuthToken = (state: RootState) => {
  return state.auth.account.idToken;
};

export const selectRootOrganizationId = (state: RootState) => {
  return state.createCohort.rootOrganizationId;
};

export const selectDataSourceId = (state: RootState) => {
  return state.createCohort.dataSourceId;
};

export const selectToastState = (state: RootState) => {
  return state.toast;
};

export const selectFeatureFlagIdentitySet = (state: RootState) => {
  return state.auth.featureFlagIdentitySet;
};
